import { render, staticRenderFns } from "./AirWallexBtn.vue?vue&type=template&id=8bfcba1c&scoped=true&"
import script from "./AirWallexBtn.vue?vue&type=script&lang=js&"
export * from "./AirWallexBtn.vue?vue&type=script&lang=js&"
import style0 from "./AirWallexBtn.vue?vue&type=style&index=0&id=8bfcba1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfcba1c",
  null
  
)

export default component.exports